import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from "@material-ui/core";
import * as React from "react";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import PeopleIcon from "@material-ui/icons/People";
import HelpIcon from "@material-ui/icons/Help";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import { Redirect } from "react-router-dom";
import ManageUsersDialog from "../dialogs/ManageUsersDialog";
import ManageNotificationsDialog from "../dialogs/ManageNotificationsDialog";
import { AuthConsumer } from "../routes/AuthContext";
import HasPermission from "../auth/HasPermission";
import AuditIcon from "@material-ui/icons/Assignment";
import HasMutablePermission from "../auth/HasMutablePermission";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import ConfigurationsDialog from "../dialogs/ConfigurationsDialog";
import AccessConfigurationsDialog from "../dialogs/AccessConfigurationsDialog";
import ManageCompanyUsersDialog from "../dialogs/ManageCompanyUsersDialog";
import { CompaniesService } from "../services/CompaniesService";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import SelectDashboardDialog from "../dialogs/SelectDashboardDialog";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  profileData: any;
  companies: any;
  onHelperClicked: any;
  company?: any;
}
class SettingsScreen extends React.Component<Props> {
  state = {
    logout: false,
    openManageUsersDialog: false,
    openManageNotificationsDialog: false,
    openConfigurationDialog: false,
    openAccessDialog: false,
    from: "ADMIN",
    openHelpDialog: false,
    openCompanyManageUsersDialog: false,
    openSelectDashboard: false,
  };

  handleOnSubmit = () => {};
  handleClose = () => {
    this.setState({
      openManageUsersDialog: false,
      openManageNotificationsDialog: false,
      openHelpDialog: false,
      openConfigurationDialog: false,
      openAccessDialog: false,
      openAddAccessConfigDialog: false,
      openCompanyManageUsersDialog: false,
    });
  };
  handleOnManageUsers = () => {
    this.setState({
      openManageUsersDialog: true,
      from: "ADMIN",
    });
  };
  handleOnManageCompanyUsers = () => {
    this.setState({
      openCompanyManageUsersDialog: true,
      from: "ADMIN",
    });
  };
  handleOnNotifications = () => {
    this.setState({
      openManageNotificationsDialog: true,
    });
  };
  handleOnConfigurations = () => {
    this.setState({
      openConfigurationDialog: true,
    });
  };
  handleOnAccess = () => {
    this.setState({
      openAccessDialog: true,
    });
  };
  handleOnDashbaord = () => {
    this.setState({
      openSelectDashboard: true,
    });
  };

  renderSelectDashbaordDialog = () => {
    return (
      <SelectDashboardDialog
        dialogTitle={`Select dashboard`}
        open={this.state.openSelectDashboard}
        company={this.props.company}
        onClose={() => {
          this.setState({
            openSelectDashboard: false,
          });
        }}
      />
    );
  };

  handleOnSubmitCompanyUsers = (values: any) => {
    const { profileData } = this.props;
    if (profileData.companyId) {
      let companiesService: CompaniesService = new CompaniesService();
      this.setState({ isLoading: true });
      EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
      companiesService
        .updateCompany(profileData.companyId, values)
        .then((resp) => {
          EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
          if (resp && resp.success) {
            this.setState({ isLoading: false, openAddCompanyDialog: false });
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Edited Successfully",
            });
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            this.setState({ isLoading: false });
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: "Oops something happened",
            });
          }
        });
    }
  };

  renderManageUsersDialog = (accessRules: any) => {
    const { profileData } = this.props;
    if (
      HasMutablePermission({
        role: profileData.role,
        perform: "users:view",
        accessRules: accessRules,
        data: profileData.role,
      })
    ) {
      return (
        <ManageUsersDialog
          title={"Add Administrators"}
          mode={"ADD"}
          companyData={{}}
          open={this.state.openManageUsersDialog}
          handleClose={this.handleClose}
          handleOnSubmit={this.handleOnSubmit}
        />
      );
    }
  };

  renderCompanyManageUsersDialog = () => {
    const { company } = this.props;
    return (
      <ManageCompanyUsersDialog
        title={`Manage Users for: ${company.name}`}
        mode={"ADD"}
        companyData={company}
        open={this.state.openCompanyManageUsersDialog}
        handleClose={this.handleClose}
        handleOnSubmit={this.handleOnSubmitCompanyUsers}
      />
    );
  };

  renderNotificationsDialog = () => {
    return (
      <ManageNotificationsDialog
        open={this.state.openManageNotificationsDialog}
        dialogTitle={"Manage Notifications"}
        onClose={this.handleClose}
        profileData={this.props.profileData}
        companies={this.props.companies}
      />
    );
  };

  renderConfigurationsDialog = () => {
    return (
      <ConfigurationsDialog
        open={this.state.openConfigurationDialog}
        dialogTitle={"Configurations"}
        onClose={this.handleClose}
      />
    );
  };
  renderAccessDialog = () => {
    return (
      <AccessConfigurationsDialog
        open={this.state.openAccessDialog}
        dialogTitle={"Access Configurations"}
        handleClose={this.handleClose}
      />
    );
  };
  render() {
    const { classes, profileData, onHelperClicked } = this.props;
    return (
      <React.Fragment>
        {this.renderNotificationsDialog()}
        {this.renderConfigurationsDialog()}
        {this.renderAccessDialog()}
        {profileData &&
          profileData.companyId &&
          this.renderSelectDashbaordDialog()}
        {profileData &&
          profileData.companyId &&
          this.renderCompanyManageUsersDialog()}
        {!profileData ||
          (profileData === "undefined" && <Redirect to="/segpi/" />)}
        {profileData && (
          <AuthConsumer>
            {({ logout, user, accessRules }) => (
              <List className={classes.root} style={{ margin: 10 }}>
                <div>
                  {this.renderManageUsersDialog(accessRules)}
                  <HasPermission
                    role={user.role}
                    accessRules={accessRules}
                    perform="users:view"
                    data={user.role}
                    yes={() => (
                      <Box boxShadow={1}>
                        <ListItem
                          style={{ borderColor: "black", borderWidth: 2 }}
                          button
                          onClick={() => this.handleOnManageUsers()}
                        >
                          <ListItemIcon>
                            <PeopleIcon />
                          </ListItemIcon>
                          <ListItemText primary="Manage Users" />
                        </ListItem>
                      </Box>
                    )}
                    no={() => <div></div>}
                  />
                  {profileData && profileData.companyId && (
                    <HasPermission
                      role={user.role}
                      accessRules={accessRules}
                      perform="company-users:view"
                      data={user.role}
                      yes={() => (
                        <Box boxShadow={1}>
                          <ListItem
                            style={{ borderColor: "black", borderWidth: 2 }}
                            button
                            onClick={() => this.handleOnManageCompanyUsers()}
                          >
                            <ListItemIcon>
                              <PeopleIcon />
                            </ListItemIcon>
                            <ListItemText primary="Manage Users" />
                          </ListItem>
                        </Box>
                      )}
                      no={() => <div></div>}
                    />
                  )}

                  <HasPermission
                    role={user.role}
                    accessRules={accessRules}
                    perform="notifications:view"
                    data={user.role}
                    yes={() => (
                      <Box boxShadow={1}>
                        <ListItem
                          style={{ borderColor: "black", borderWidth: 2 }}
                          button
                          onClick={() => this.handleOnNotifications()}
                        >
                          <ListItemIcon>
                            <NotificationsNoneIcon />
                          </ListItemIcon>
                          <ListItemText primary="Notifications" />
                        </ListItem>
                      </Box>
                    )}
                    no={() => <div></div>}
                  />
                  <HasPermission
                    role={user.role}
                    accessRules={accessRules}
                    perform="configurations:manage"
                    data={user.role}
                    yes={() => (
                      <Box boxShadow={1}>
                        <ListItem
                          style={{ borderColor: "black", borderWidth: 2 }}
                          button
                          onClick={() => this.handleOnConfigurations()}
                        >
                          <ListItemIcon>
                            <SettingsIcon />
                          </ListItemIcon>
                          <ListItemText primary="Configurations" />
                        </ListItem>
                      </Box>
                    )}
                    no={() => <div></div>}
                  />
                  <HasPermission
                    role={user.role}
                    accessRules={accessRules}
                    perform="access:manage"
                    data={user.role}
                    yes={() => (
                      <Box boxShadow={1}>
                        <ListItem
                          style={{ borderColor: "black", borderWidth: 2 }}
                          button
                          onClick={() => this.handleOnAccess()}
                        >
                          <ListItemIcon>
                            <AccountTreeIcon />
                          </ListItemIcon>
                          <ListItemText primary="Access" />
                        </ListItem>
                      </Box>
                    )}
                    no={() => <div></div>}
                  />
                  {user.companyId && (
                    <HasPermission
                      role={user.role}
                      accessRules={accessRules}
                      perform="dashboard:view"
                      data={user.role}
                      yes={() => (
                        <Box boxShadow={1}>
                          <ListItem
                            style={{ borderColor: "black", borderWidth: 2 }}
                            button
                            onClick={() => this.handleOnDashbaord()}
                          >
                            <ListItemIcon>
                              <AuditIcon />
                            </ListItemIcon>
                            <ListItemText primary="Dashboard" />
                          </ListItem>
                        </Box>
                      )}
                      no={() => <div></div>}
                    />
                  )}
                </div>
                <Divider />
                <Box boxShadow={1}>
                  <ListItem button onClick={() => onHelperClicked()}>
                    <ListItemIcon>
                      <HelpIcon />
                    </ListItemIcon>
                    <ListItemText primary="Help" />
                  </ListItem>
                </Box>

                <Box
                  boxShadow={1}
                  style={{
                    marginTop: 10,
                    color: "black",
                  }}
                >
                  <ListItem button onClick={logout}>
                    <ListItemIcon>
                      <LockOpenIcon />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                  </ListItem>
                </Box>
              </List>
            )}
          </AuthConsumer>
        )}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(SettingsScreen);
